const size = {
  phoneMaxWidth: 599,
  tabletMinWidth: 600,
  tabletMaxWidth: 839,
  desktopMinWidth: 840,
  desktopSmallMinWidth: 840,
  desktopSmallMaxWidth: 1023,
  desktopMediumMinWidth: 1024,
  desktopMediumMaxWidth: 1279,
  desktopLargeMinWidth: 1280,
  tvMinWidth: 1440,
  lineWidth: 750
}

export const frnt = {
  primary: '#1A1A35',
  primaryRgb: '26, 26, 53',
  primary2: '#424AF9',
  primary2Rgb: '66, 74, 249',
  primary3: '#FFA61E',
  primary3Rgb: '255, 166, 30',
  secondary: '#2C2C48',
  secondaryRgb: '44, 44, 72',
  secondary2: '#545CF9',
  secondary2Rgb: '84, 92, 249',
  secondary3: '#FFAE34',
  secondary3Rgb: '255, 174, 52',
  secondary4: '#6F719F',
  secondary4Rgb: '111, 113, 159',
  secondary5: '#7579DD',
  secondary5Rgb: '117, 121, 221',
  secondary6: '#ECD9BE',
  secondary6Rgb: '236, 217, 190',
  neutral: '#FFFFFF',
  neutral2: '#F6F8FA',
  neutral3: '#E4E7EE',
  neutral4: '#898997',
  neutral4Rgb: '137, 137, 151',
  onNeutral: '#000000',
  onNeutral2: '#000000',
  onNeutral3: '#000000',
  onNeutral4: '#000000',
  success: '#72BF57',
  successRgb: '114, 191, 87',
  error: '#E55049',
  errorRgb: '229, 80, 73',
  disabled: '#E4E7EE',
  onPrimary: '#FFFFFF',
  onPrimaryRgb: '255, 255, 255',
  borderOnPrimary: '#6F719F',
  onPrimary2: '#FFFFFF',
  onPrimary2Rgb: '255, 255, 255',
  onPrimary3: '#FFFFFF',
  onSecondary: '#FFFFFF',
  onSecondary2: '#FFFFFF',
  onSecondary3: '#FFFFFF',
  onSecondary3Rgb: '255, 255, 255',
  onSecondary4: '#FFFFFF',
  onSecondary5: '#FFFFFF',
  onSecondary6: '#FFFFFF',
  onSuccess: '#FFFFFF',
  onError: '#FFFFFF',
  onDisabled: '#898997',
  textPrimaryOnBackground: '#000000',
  textNeutralOnPrimary: '#FFFFFF',
  textNeutralOnPrimary2: '#FFFFFF',
  textPrimaryOnNeutral: '#1A1A35',
  textPrimary2OnNeutral: '#424AF9',
  textHintOnPrimary2: '#424AF9',

  // TODO stevo: these css vars are used by market-data-webapp; rewrite it to use colors generated dynamically and then remove these CSS vars
  colorLightBlue: '#32B0EE',
  colorRoyalBlue: '#1C2592',
  colorGreen: '#1AA9A4',
  colorRed: '#EB5757',
  iconDarkBlueDot: '#388EFE',
  iconAshGrayDot: '#565656',

  devicePhone: `(max-width: ${size.phoneMaxWidth}px)`,
  deviceTablet: `(min-width: ${size.tabletMinWidth}px) and (max-width: ${size.tabletMaxWidth}px)`,
  deviceDesktop: `(min-width: ${size.desktopMinWidth}px)`,
  deviceDesktopSmall: `(min-width: ${size.desktopSmallMinWidth}px) and (max-width: ${size.desktopSmallMaxWidth}px)`,
  deviceDesktopMedium: `(min-width: ${size.desktopMediumMinWidth}px) and (max-width: ${size.desktopMediumMaxWidth}px)`,
  deviceDesktopLarge: `(min-width: ${size.desktopLargeMinWidth}px)`,
  deviceTv: `(min-width: ${size.tvMinWidth}px)`,

  devicePhoneMaxWidth: size.phoneMaxWidth,
  deviceTabletMinWidth: size.tabletMinWidth,
  deviceTabletMaxWidth: size.tabletMaxWidth,
  deviceDesktopMinWidth: size.desktopMinWidth,
  deviceDesktopSmallMinWidth: size.desktopSmallMinWidth,
  deviceDesktopSmallMaxWidth: size.desktopSmallMaxWidth,
  deviceDesktopLargeMinWidth: size.desktopLargeMinWidth,
  deviceTvMinWidth: size.tvMinWidth,
  deviceLineWidth: size.lineWidth
}
